import React from "react";
import { DeleteButton, EditButton, List, ShowButton, useTable } from "@refinedev/antd";
import { Space, Table, Typography } from "antd";
import type { FieldDef } from "@evo-flywheel/contracts";
import { useResource } from "@refinedev/core";
import { ListSlots, OrgScopeBar, TONE_FRAME_CLASS, useListReplacement, useOrgScope } from "@evo-flywheel/ui";
import { resourceBySlug } from "../kit-resources";
import { renderCell } from "../fields";
import { RefCell } from "../modules/refs";

export const GenericList: React.FC = () => {
  const { resource } = useResource();
  const Replacement = useListReplacement(resource?.name);
  if (Replacement) return <><OrgScopeBar slug={resource?.name} /><ListSlots slug={resource?.name} only="actions" /><Replacement slug={resource!.name} /></>;
  return <GeneratedList />;
};

/** Generated list; the module's slots (actions, summary tiles, header panels) render above it.
 * The organisation scope (ADR-037) narrows it; with several companies on screen a "Società" column
 * says which one each row belongs to ("di gruppo" when it names none). */
const GeneratedList: React.FC = () => {
  const { resource } = useResource();
  const slug = resource?.name;
  const meta = resourceBySlug[slug ?? ""]?.meta;
  const scope = useOrgScope(slug);
  const { tableProps } = useTable({ syncWithLocation: true, filters: { permanent: scope.filters } });
  const fields = new Map<string, FieldDef>((meta?.fields ?? []).map((field) => [field.name, field]));
  const orgColumn = scope.aggregated && !scope.fields.some((f) => meta?.listView?.includes(f));
  return <>
    <OrgScopeBar slug={slug} />
    <ListSlots slug={slug} />
    <List wrapperProps={{ className: TONE_FRAME_CLASS }}>
      <Table {...tableProps} rowKey="id">
        {orgColumn && <Table.Column key="_org" title="Società" render={(_, record: Record<string, unknown>) => {
          const id = scope.fields.map((f) => record[f]).find((v) => typeof v === "string" && v);
          return id ? <RefCell id={String(id)} /> : <Typography.Text type="secondary">di gruppo</Typography.Text>;
        }} />}
        {(meta?.listView ?? []).map((name) => <Table.Column key={name} dataIndex={name} title={fields.get(name)?.label ?? name} render={(value) => renderCell(fields.get(name), value, slug)} />)}
        <Table.Column title="Azioni" render={(_, record: { id?: string }) => <Space><ShowButton hideText size="small" recordItemId={record.id} /><EditButton hideText size="small" recordItemId={record.id} /><DeleteButton hideText size="small" recordItemId={record.id} /></Space>} />
      </Table>
    </List>
  </>;
};
